



















import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { SerializedAspectValueDescriptor } from '@xlearn/common';
import Debug from 'debug'

  const debug = Debug('aspect-dropdown-component')

  @Component
  export default class AspectDropdownComponent extends Vue {
    @Prop()
    public values: SerializedAspectValueDescriptor[];

    @Prop()
    public aspectNameStr: string;

    @Prop()
    public level: number;

    private selectedId: string = '';

    private onAspectValueClicked(event: Event) {
      const id = (event.target as HTMLSelectElement).value;
      this.$emit('selected', id)
    }

  }

